<template>
  <tbody class="thead">
    <tr>
      <th class="sticky-cell">
        <template v-if="!tableIsTeam"> Date </template>
        <template v-else>
          <template v-if="reportQuery.group_by === 'member'">Date</template>
          <template v-else-if="reportQuery.group_by === 'date'">Member</template>
        </template>
      </th>
      <th>Status</th>
      <th>Shift</th>
      <th>Start time</th>
      <th>Required</th>
      <th>Actual</th>
      <th v-if="showActivityPercentage">Activity %</th>
      <th>Late</th>
    </tr>
  </tbody>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AttendanceReportTableHeader',
  props: {
    showActivityPercentage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['reportQuery', 'tableIsTeam']),
  },
};
</script>
